<template>
    <div>
        <el-dialog 
            title="发起工单" 
            :visible.sync="dialogVisible"  
            :width="width" 
            style="padding:0px;"
            :close-on-click-modal="false">
            <div style="display:flex;">
                <div>
                    <el-form ref="form" label-width="80px">
                        <el-form-item label="工单编号">
                            <el-input v-model="no" style="width:80%;"></el-input>
                        </el-form-item>
                        <el-form-item label="开始时间">
                            <el-date-picker
                                v-model="beginTime"
                                type="datetime"
                                placeholder="选择日期时间"
                                align="right"
                                style="width:80%;">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="泊位">
                            <el-select v-model="berthId" placeholder="泊位" style="width:80%;">
                                <el-option v-for="item in berthListAvailable" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="堆场">
                            <el-select v-model="areaId" placeholder="堆场" style="width:80%;">
                                <el-option v-for="item in areaListAvailable" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="操作量">
                            <el-select v-model="typeId" placeholder="堆场" style="width:80%;">
                                <el-option v-for="item in typeListAvailable" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select>
                            <el-input v-model="number" style="width:40%;display:none;" type="text" onkeyup="value=value.replace(/[^\d]/g,'')" size="small" placeholder="请输入数字"></el-input>
                        </el-form-item>
                        <el-form-item label="码头设备" style="display:none;">
                            <el-checkbox v-for="(item,index) in dockDevListAvailable" :key="item.id" v-model="dockDevsState[index]" :value="item.id">{{item.name}}</el-checkbox>
                        </el-form-item>
                        <el-form-item label="作业流程">
                            <el-input v-model="beltName" placeholder="请选择作业流程" :disabled="true" style="width:40%;"></el-input>
                            <el-divider direction="vertical"></el-divider>
                            <el-button @click="subDialogVisible = true">选择流程</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="dialog-device" style="height:400px; width:300px;">
                    <div>码头设备</div>
					<elCheckBoxTree ref="tree" @checkItem="checkItemList" :dataList='virtualDeviceList' style="height:400px; width:320px;"></elCheckBoxTree>
				</div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog 
            title="提示" 
            :visible.sync="subDialogVisible"  
            :width="width" 
            style="padding:0px;z-index:5000"
            :close-on-click-modal="false">
            <el-row style="width:100%; padding:15px;">
                <el-col :span="16">
                    <el-form label-width="120px">
                        <el-form-item label="输入查询内容">
                            <el-input v-model="search" style="width:200px;"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="8">
                    <el-button @click="loadData" type="primary">查询</el-button>
                </el-col>
            </el-row>
            <el-table :data="tableData" style="width: 100%; min-height:450px;">
                <el-table-column prop="name" label="流程号" width="150"></el-table-column>
                <el-table-column prop="lastEfficiency" label="上次能效" width="250"></el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button @click="selectBelt(scope.row)" type="text">选择</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <center>
                <el-pagination
                    @prev-click="prePage"
                    @next-click="nextPage"
                    @current-change="pageChange"
                    :page-size="pageSize"
                    :pager-count="11"
                    layout="prev, pager, next"
                    :total="total">
                </el-pagination>
            </center>
        </el-dialog>
    </div>
</template>
<script>
import elCheckBoxTree from '@/page/projectDingZhi/ningbo/elCheckBoxTree.vue'
export default {
    components:{
        elCheckBoxTree,
    },
    data(){
        return{
            no:'',
            beginTime:'',
            berthId:'',
            areaId:'',
            typeId:'',
            number:'0',
            beltId:'',
            beltName: '',
            search: '',
            pageIndex:0,
            pageSize:10,
            pageCount:0,
            total:0,
            tableData: [],
            dockDevsState:[],
            dockDevsName:[],

            dialogVisible: false,
            subDialogVisible: false,
            width:'200',
            selectDeviceList: [], //选中的设备
        }
    },
    computed:{
        virtualDeviceList() {
            var data = this.$store.deviceStore.getters.getReadDeviceTree
            return isempty(data) ? [] : [deviceList(data)]
        },
        bindedDeviceNos() {
            return ownerManagerStore.state.bindedDeviceNos
        },
        berthListAvailable(){
            var bl = this.$store.ningboStore.getters.getBerthList.slice()
            var abl = []
            for(var i=0; i<bl.length; i++){
                var item = bl[i];
                if(item.state == 1){
                    abl.push(item)
                }
            }
            return abl;
        },
        berthList(){
            return this.$store.ningboStore.getters.getBerthList;
        },
        areaListAvailable(){
            var bl = this.$store.ningboStore.getters.getAreaList.slice()
            var abl = []
            for(var i=0; i<bl.length; i++){
                var item = bl[i];
                if(item.state == 1){
                    abl.push(item)
                }
            }
            return abl;
        },
        areaList(){
            return this.$store.ningboStore.getters.getAreaList;
        },
        typeListAvailable(){
            var bl = this.$store.ningboStore.getters.getTypeList.slice()
            var abl = []
            for(var i=0; i<bl.length; i++){
                var item = bl[i];
                if(item.state == 1){
                    abl.push(item)
                }
            }
            return abl;
        },
        typeList(){
            return this.$store.ningboStore.getters.getTypeList;
        },
        dockDevListAvailable(){
            var bl = this.$store.ningboStore.getters.getDockDevList.slice()
            var abl = []
            for(var i=0; i<bl.length; i++){
                var item = bl[i];
                if(item.state == 1){
                    abl.push(item)
                }
            }
            return abl;
        },
        dockDevList(){
            return this.$store.ningboStore.getters.getDockDevList;
        }
    },
    mounted(){
        this.loadData();
        var bl = this.$store.ningboStore.getters.getDockDevList.slice()
        for(var i=0; i<bl.length; i++){
            var item = bl[i];
            if(item.state == 1){
                this.dockDevsState.push(false);
                this.dockDevsName.push(item.name);
            }
        }
    },
    watch:{
        beginTime(nv, ov){
            console.log(nv.format('yyyy-MM-dd hh:mm:ss'))
        },
        dockDevsState(nv, ov){
            console.log(nv);
        }
    },
    methods:{
        open(){
            this.no = ''
            this.beginTime = ''
            this.berthId = ''
            this.areaId = ''
            this.typeId = ''
            this.number = ''
            this.beltId = ''
            this.beltName = ''
            this.search = ''
            this.dialogVisible = true;
            this.$refs.tree.cleanTree();
        },
        loadData(){
            this.$api.ningboApi.findAllBeltOrderByEfficiency(this.search, this.pageIndex, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        searchData(){
            this.pageIndex = 0;
            this.loadData();
        },
        prePage(){
            this.$api.ningboApi.findAllBelt(this.search, this.pageIndex - 1, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        nextPage(){
            this.$api.ningboApi.findAllBelt(this.search, this.pageIndex + 1, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        pageChange(page){
            this.$api.ningboApi.findAllBelt(this.search, page, this.pageSize, response => {
                this.refreshData(response);
            })
        },
        refreshData(data){
            this.pageIndex = data.data.pageIndex;
            this.pageSize = data.data.pageSize;
            this.pageCount = data.data.pageCount;
            this.total = data.data.total;
            this.tableData = data.data.list;
        },
        selectBelt(row){
            console.log(row)
            this.subDialogVisible = false;
            this.beltId = row.id;
            this.beltName = row.name;
        },
        validate(){
            if(this.no == ''){
                return '请输入工单编号'
            }
            if(this.beginTime == ''){
                return '请输开始时间'
            }
            if(this.berthId == ''){
                return '请选择泊位'
            }
            if(this.areaId == ''){
                return '请选择堆场'
            }
            if(this.typeId == ''){
                return '请选择操作类型'
            }
            // if(this.number == ''){
            //     return '请输操作量'
            // }
            if(this.beltId == ''){
                return '请选择皮带流程'
            }
            return ''
        },
        save(){
            var msg = this.validate();
            if(msg.length > 0){
                this.$message({
                    type: 'error',
                    message: msg
                });
                return;
            }

            var dockDevs = '';
            for(var i=0; i<this.dockDevsState.length; i++){
                if(this.dockDevsState[i]){
                    if(dockDevs.length > 0){
                        dockDevs += ',';
                    }
                    dockDevs += this.dockDevListAvailable[i].name
                }
            }

            var deviceNo = '';
            var deviceName = '';
            for(var i=0; i<this.selectDeviceList.length; i++){
                if(this.selectDeviceList[i]['type'] == 'group'){
                    continue;
                }
                deviceNo += this.selectDeviceList[i].no + ',';
                deviceName += this.selectDeviceList[i].label + ',';
            }

            this.number = 0;
            this.$api.ningboApi.newWorkorder(this.no, this.beginTime.format('yyyy-MM-dd hh:mm:ss'), this.beltId, this.berthId, this.areaId, this.typeId, this.number, deviceNo, deviceName,
                respon => {
                    this.dialogVisible = false;
                    this.$emit('saveSuccess')
                    this.$message({
                        type: 'success',
                        message: '保存成功'
                    });
                },
                failure => {
                    this.$message({
                        type: 'error',
                        message: failure
                    });
                }
            )
        },
        checkItemList(list) {
            this.selectDeviceList = list.slice();
            for(var i=this.selectDeviceList.length-1; i>=0; i--){
                if(this.selectDeviceList[i]['type'] == 'group'){
                    this.selectDeviceList.splice(i,1);
                }
            }
        },
    }
}
</script>